import React from 'react';

import {
  FormattedCode,
  OrderAndReturnToggle
} from 'modules/layer00';
import {
  BaseWidget,
  selectFields
} from 'modules/layer01';

import { Typography } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const SalesOrderSelectField = selectFields.SalesOrderSelectField.genComponentAndControllerGenerator(props.storeId);
  const ReturnAuthorizationSelectField = selectFields.ReturnAuthorizationSelectField.genComponentAndControllerGenerator(props.storeId);
  const [viewType, setViewType] = React.useState<OrderAndReturnToggle.IViewType>('order');
  const [fnQuery, tuple] = dataService.useLazyQuery(viewType === 'order');
  const [
    selectedOrder,
    setSelectedOrder
  ] = React.useState<selectFields.SalesOrderSelectField.ISalesOrder | null>(null);
  const [
    selectedReturnAuthorization,
    setSelectedReturnAuthorization
  ] = React.useState<selectFields.ReturnAuthorizationSelectField.IReturnAuthorizationSelectField | null>(null);



  React.useEffect(
    () => {
      if (viewType === 'order' && selectedOrder) {
        fnQuery(selectedOrder.id);

      } else if (viewType === 'returnAuthorization' && selectedReturnAuthorization) {
        fnQuery(selectedReturnAuthorization.id);
      }
    },
    [
      selectedOrder,
      viewType,
      selectedReturnAuthorization,
      fnQuery
    ]
  );



  return (
    <BaseWidget.FC title="Dynamic Data Example">
      <Typography>
        The data below is an example of how the data is structured when received by SendGrid. You can use this structure
        to input data into your templates.
      </Typography>

      <OrderAndReturnToggle.FC
        viewType={viewType}
        onChangeViewType={setViewType} />

      {viewType === 'order' && (
        <SalesOrderSelectField.FC
          label="Sales Order"
          selectProps={{
            type: 'singleSelect',
            value: selectedOrder,
            onChange: value => setSelectedOrder(value)
          }} />
      )}

      {viewType === 'returnAuthorization' && (
        <ReturnAuthorizationSelectField.FC
          label="Return Authorization"
          selectProps={{
            type: 'singleSelect',
            value: selectedReturnAuthorization,
            onChange: value => setSelectedReturnAuthorization(value)
          }} />
      )}

      <FormattedCode.FC content={tuple.data.order} />
    </BaseWidget.FC>
  );
};
